/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import polyfills first (before anything else)
import '../polyfills';

// Needed for redux-saga generator support
import 'regenerator-runtime/runtime';

// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import history from 'utils/history';
import 'sanitize.css/sanitize.css';

// Import root app
import App from 'containers/App';

// Import Language Provider
import SettingsProvider from 'containers/SettingsProvider';
import setupCacheCleanup from 'utils/swCacheCleanup';
import registerServiceWorker from 'utils/registerServiceWorker';

import configureStore from './configureStore';

// Import i18n messages
import { translationMessages } from './i18n';

// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('app');

const render = messages => {
  ReactDOM.render(
    <Provider store={store}>
      <SettingsProvider messages={messages}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </SettingsProvider>
    </Provider>,
    MOUNT_NODE,
  );
};

// Chunked polyfill for browsers without Intl support
if (window.Intl) {
  render(translationMessages);
} else {
  import('intl')
    .then(() =>
      Promise.all([
        import('intl/locale-data/jsonp/en'),
        import('intl/locale-data/jsonp/nl'),
      ]),
    )
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
}

// Setup service worker cache cleanup
setupCacheCleanup();

// Register the service worker with an error handler so registration
// failures don't surface as unhandled promise rejections
registerServiceWorker();
